'use client';

import React, { forwardRef } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { FilledSpinnerIos } from '../../../../../common/svgIcons';

type TopBarMenuButtonProps = React.PropsWithChildren<{
  isLoading?: boolean;
  ariaLabel?: string;
  className?: string;
}>;

export const TopBarMenuButton = forwardRef<
  HTMLButtonElement,
  TopBarMenuButtonProps
>(({ children, isLoading, ariaLabel, className, ...rest }, ref) => {
  return (
    <button
      type="button"
      ref={ref}
      aria-label={ariaLabel || 'open menu button'}
      className={`${css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'extra_small_2',
        p: 'extra_small_2',
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': {
          backgroundColor: 'neutrals.fill_focused',
        },
        borderRadius: '4px',
        transition: 'background-color 0.3s',
      })} ${className ?? ''}`}
      disabled={isLoading}
      {...rest}
    >
      {children}

      {isLoading ? (
        <FilledSpinnerIos
          aria-label="loading icon"
          data-element="loading-icon"
        />
      ) : null}
    </button>
  );
});

TopBarMenuButton.displayName = 'TopBarMenuButton';
